import useApi, { RESET_PASSWORD } from 'hooks/useApi';

const useResetPassword = () => {
  const [state, makeRequest] = useApi();

  const resetPassword = (newPassword, resetId) => {
    makeRequest(RESET_PASSWORD({ newPassword, resetId }));
  };

  const getResetId = path => {
    const queryParam = path.split('resetId=');
    return queryParam[1];
  };

  return [state, resetPassword, getResetId];
};
export default useResetPassword;
